(function () {
  function initCarousel(section) {
    if (section.dataset.ecCarouselInit === '1') return;
    section.dataset.ecCarouselInit = '1';

    const wrap = section.querySelector('.ec-carousel__wrap');
    const grid = section.querySelector('.ec-carousel__grid');
    if (!grid) return;
    const items = grid.querySelectorAll('.ec-carousel__item');
    if (items.length === 0) return;
    const prev = section.querySelector('.ec-carousel__arrow--prev');
    const next = section.querySelector('.ec-carousel__arrow--next');
    const dotsWrap = section.querySelector('.ec-carousel__dots');

    const carouselDesktop = section.dataset.carouselDesktop === 'true';
    const carouselMobile = section.dataset.carouselMobile === 'true';
    const itemsMobile = section.dataset.itemsMobile || '1';
    const itemsDesktop = parseInt(section.dataset.itemsDesktop, 10) || 3;
    const infinite = section.dataset.infinite === 'true';

    grid.setAttribute('data-mobile', itemsMobile);

    function isMobile() { return window.matchMedia('(max-width: 1023px)').matches; }

    function applyCarouselClasses() {
      const mobile = isMobile();
      const shouldCarousel = (mobile && carouselMobile) || (!mobile && carouselDesktop);
      section.classList.toggle('is-carousel', shouldCarousel);
      section.classList.toggle('is-carousel-desktop', !mobile && carouselDesktop);
      section.classList.toggle('is-carousel-mobile', mobile && carouselMobile);
      section.classList.toggle('is-infinite', shouldCarousel && infinite);
    }

    applyCarouselClasses();

    function visibleCount() {
      if (isMobile()) {
        const m = parseFloat(itemsMobile);
        return Math.max(1, Math.floor(m));
      }
      if (window.matchMedia('(max-width: 1023px)').matches) return 2;
      return itemsDesktop;
    }

    function totalPages() {
      const v = visibleCount();
      return Math.max(1, items.length - v + 1);
    }

    let current = 0;
    let touchTimer;

    function updateArrows() {
      if (!prev || !next) return;
      const pages = totalPages();
      if (pages <= 1) {
        prev.classList.add('is-disabled');
        next.classList.add('is-disabled');
        section.classList.remove('has-overflow');
        return;
      }
      section.classList.add('has-overflow');

      if (section.classList.contains('is-infinite')) {
        prev.classList.remove('is-disabled');
        next.classList.remove('is-disabled');
        return;
      }

      prev.classList.toggle('is-disabled', current <= 0);
      next.classList.toggle('is-disabled', current >= pages - 1);
    }

    function showControls() {
      if (!wrap) return;
      wrap.classList.add('is-touching');
      clearTimeout(touchTimer);
      touchTimer = setTimeout(function () { wrap.classList.remove('is-touching'); }, 1600);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const pages = totalPages();
      if (pages <= 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('span');
        dot.className = 'ec-carousel__dot' + (i === current ? ' active' : '');
        dot.addEventListener('click', function () { goToSlide(i); });
        dot.addEventListener('touchstart', showControls, { passive: true });
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.ec-carousel__dot').forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    function goToSlide(index) {
      const max = totalPages() - 1;
      const isInfinite = section.classList.contains('is-infinite');

      if (isInfinite) {
        if (index > max) index = 0;
        else if (index < 0) index = max;
      } else {
        if (index < 0) index = 0;
        if (index > max) index = max;
      }

      current = index;
      const target = items[index];
      if (!target) return;
      grid.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      updateDots();
      updateArrows();
      showControls();
    }

    grid.addEventListener('scroll', function () {
      const max = totalPages() - 1;
      const scrollEnd = grid.scrollLeft + grid.clientWidth;
      const atEnd = scrollEnd >= grid.scrollWidth - 2;
      const atStart = grid.scrollLeft <= 2;
      let newIndex;
      if (atEnd) newIndex = max;
      else if (atStart) newIndex = 0;
      else {
        let closestIndex = 0;
        let closestDistance = Infinity;
        items.forEach(function (item, i) {
          const distance = Math.abs(grid.scrollLeft - item.offsetLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });
        if (closestIndex > max) closestIndex = max;
        newIndex = closestIndex;
      }
      current = newIndex;
      updateDots();
      updateArrows();
    });

    if (prev) {
      prev.addEventListener('click', function () { goToSlide(current - 1); });
      prev.addEventListener('touchstart', showControls, { passive: true });
    }
    if (next) {
      next.addEventListener('click', function () { goToSlide(current + 1); });
      next.addEventListener('touchstart', showControls, { passive: true });
    }

    grid.addEventListener('touchstart', showControls, { passive: true });
    grid.addEventListener('touchend', showControls, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyCarouselClasses();
        current = 0;
        grid.scrollTo({ left: 0, behavior: 'auto' });
        buildDots();
        updateArrows();
      }, 150);
    });

    buildDots();
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.ec-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();